export default "__VITE_ASSET__BvlNVfea__"